import './index.scss';
import React, { useEffect } from 'react';
import { Check } from 'react-feather';
import { GymResource } from '../../../../store/gym-management/GymTypes';
import LoadGauge from '../../book-room/LoadGauge';
import { useFetchResourceAlloc } from '../../../../store/RoomManagement/resourceManagementHooks';

type PropsTypes = {
  gym: GymResource;
  form: any;
};

const BookGymInfo = (props: PropsTypes) => {
  const { form } = props;

  return (
    <div className="book-gym-info">
      <div className="book-gym-info-name-title">{props.gym.name}</div>
      <div className="book-gym-info-image">
        <img
          src={
            props.gym.image ||
            '//cdn.pixabay.com/photo/2017/03/28/12/17/chairs-2181994__340.jpg'
          }
          alt="room image"
        />
      </div>
      <div className="book-gym-gouge">
        <LoadGauge
          start={form.watch('start')}
          end={form.watch('end')}
          openFrom={props.gym.availableFrom}
          openTo={props.gym.availableTo}
          date={[form.watch('date')]}
          minBookingTime={props.gym.minimumBookingTime}
        />
      </div>
      <div className="book-gym-info-description">{props.gym.description}</div>

      {props.gym.equipment && Boolean(props.gym.equipment.length) && (
        <div className="book-gym-amenities">
          <div className="book-gym-amenities-title">Main amenities</div>
          <div className="book-gym-amenities-items">
            {props.gym.equipment.map((item, index) => (
              <div className="book-gym-amenities-item" key={index}>
                <Check />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BookGymInfo;
